<template>
    <div id="NotificacoesComponent">
        <div class="row">
            <div class="col-12" v-for="(notifie, index) in notifies" :key="index">
                <div class="card">
                    <div class="card-body">
                        <span class="unread-icon"><i class="fas fa-circle"></i></span>
                        <p>lalalalalalalla {{notifie}}</p>
                    </div>
                </div>
                <br>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotificacoesComponent',
    data(){
        return{
            
        }
    },
    props:{
        siteId:{
            type: Number,
            required: true
        },
        notifies:{
            type: Number,
            required: true
        }
    }
}
</script>
<style>
    #NotificacoesComponent .card{
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.14);
    }
    #NotificacoesComponent .card-body i{
        color: var(--main-color);
        font-size: 0.6rem
    }
    #NotificacoesComponent .card-body{
        padding: 10px 10px 20px;        
    }
    #NotificacoesComponent .card-body p{
        margin-bottom: 5px;
    }
    #NotificacoesComponent .card-body .unread-icon{
        position: absolute;
        right: 10px;
        top: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/NotificacoesComponent.vue